// SINGLE shared mapping of each Total-E application / portal to its FINAL approved
// icon asset. Display uses optimized 256px transparent WebP; the high-resolution
// PNG originals are retained alongside (APP_ICONS_HIRES) in /public/app-icons-final.
// Ecosystem branding (Total-E / Management) is intentionally kept DISTINCT from
// application and portal icons.
const F = '/app-icons-final';

export const APP_ICONS = {
  // Ecosystem branding
  management: '/total_e_icon.webp',
  total_e: '/total_e_icon.webp',
  // Applications
  tfs_admin: '/app_admin_hub_v2_256.webp',
  tfs_ops: '/app_ops_tfsi_v2_256.webp',
  rout_admin: '/app_rout_v2_256.webp',
  tfs_crm: '/app_reach_v2_256.webp',
  contract_budgets: '/app_tally_v2_256.webp',
  payroll: '/app_total_pay_v2_256.webp',
  calendar: '/app_calendar_v2_256.webp',
  team: `${F}/team_navy_256.webp`,
  partners: `${F}/partners_red_256.webp`,
  // Portals
  rout_client: `${F}/rout_client_v2_256.webp`,
  customers: `${F}/rout_client_v2_256.webp`,
  field: `${F}/field_worker_256.webp`,
};

export const APP_ICONS_HIRES = {
  team: `${F}/team_navy.png`,
  partners: `${F}/partners_red.png`,
  rout_client: `${F}/rout_client_v2_256.webp`,
  customers: `${F}/rout_client_v2_256.webp`,
  field: `${F}/field_worker.png`,
};

export const iconForApp = (key) => APP_ICONS[key] || null;
